import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Router } from '@angular/router';
import { IsHIVUser } from '@helpers/permissions';

export const ExcludeHivGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  
  if (IsHIVUser()) {
    router.navigate(['/home']);
    return false;
  }
  
  return true;
};
